import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class ProcessLoadingService {
  isLoading = new EventEmitter<boolean>();
}